import { PATH_INVOICE_SPECIFICATIONS, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseInvoiceSpecificationDetailsBreadcrumbsProps {
  label: string;
}

export const useInvoiceSpecificationDetailsBreadcrumbs = ({
  label,
}: UseInvoiceSpecificationDetailsBreadcrumbsProps): BreadcrumbItem[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("projectInvoiceSpecifications.title.multiple"),
        href: PATH_INVOICE_SPECIFICATIONS,
      },
      {
        label,
      },
    ],
    [t, label],
  );
};
